export default {
  customerServiceEmail: "",
  emailLink: "/#/swatch/swatchcount-edit/",
  customSort: false,
  listAutoQueryOptions: {
    url: "QuerySwatchLists.json",
    orderBy: "Id",
    views: {
      list: "th-list",
      cards: "th",
    },
    pageSize: 12,
    hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
    autoLoad: true,
    append: false,
    criteria: {
      //status: 'Active'
    },
    sortOptions: {
      Id: "Id: Low to High",
      "-Id": "Id: High to Low",
      Name: "List Name: A to Z",
      "-Name": "List Name: Z to A",
    },
  },
  autoQueryOptions: {
    url: "QuerySwatches.json",
    orderBy: "Id",
    views: {
      list: "th-list",
      cards: "th",
    },
    pageSize: 12,
    hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
    autoLoad: true,
    append: false,
    criteria: {
      //status: 'Active'
    },
    filters: [
      { groupBy: "Type" },
      { groupBy: "Grade" },
      { groupBy: "Color" },
      { groupBy: "Vendor" },
    ],
    sortOptions: {
      Id: "Id: Low to High",
      "-Id": "Id: High to Low",
      Type: "Type: A to Z",
      "-Type": "Type: Z to A",
      Grade: "Grade: A to Z",
      "-Grade": "Grade: Z to A",
      Color: "Color: A to Z",
      "-Color": "Color: Z to A",
      Vendor: "Vendor: A to Z",
      "-Vendor": "Vendor: Z to A",
    },
  },
};
